import { render } from "./Pricing3.vue?vue&type=template&id=b1e9861e"
import script from "./Pricing3.vue?vue&type=script&lang=js"
export * from "./Pricing3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__